import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import swal from 'sweetalert';
import credentialService from '../../services/credentialService';
import CredentialesPage from '../../pages/AdminControl/UpdatePassword/CredencialesPage';

const PreciosContainer = () => {
  const [open, setOpen] = useState(true);
  const history = useHistory();

  /*= =======================================================================
  Update Credenciales
======================================================================== */
  const hadleUpdate = (props) => {
    credentialService.putCredencial(props)
      .then((response) => {
        console.log('respuesta', response);
        if (response.data.success === 0) {
          swal({
            title: 'Upsss!!!!',
            text: 'Algo salio mal intenta nuevamente',
            icon: 'warning',
            button: 'Cerrar!',
            dangerMode: true,
          });
        } else {
          swal({
            title: 'Exitoso!',
            text: 'Actualizaste tu contraseña!',
            icon: 'success',
          });
          setOpen(false);
          history.push('/home');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleClose = () => {
    setOpen(false);
    history.push('/home');
  };

  return (
    <>
      <CredentialesPage
        onUpdate={hadleUpdate}
        open={open}
        handleClose={handleClose}
      />
    </>

  );
};

export default PreciosContainer;
